import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  template: '',
})
export class AbstractComponent implements OnInit, OnDestroy {
  destroy$ = new Subject();

  constructor() {}

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }
}
